export default "__VITE_ASSET__BrvQDjCI__"